import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './AwardButton.module.css';
import { CommonButton } from '_components';

export class SupervisorButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Supervisor'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={this.props.icon} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}
